import { LdSelect } from "@emdgroup-liquid/liquid/dist/react";
import styled from "@emotion/styled";

const StyledDropdown = styled(LdSelect)<{ width?: number | string }>`
  overflow: hidden;
  width: ${({ width }) => width};

  div.ld-select__btn-trigger {
    border: 1px solid #503291;
    background: #8255e4;
  }
`;

const StyledDropdownWrapper = styled.div<{
  width?: number | string;
}>`
  overflow: hidden;
  width: ${({ width }) => width};
  position: relative;
`;

const StyledDropdownButton = styled.div`
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  width: calc(100% - 40px);
  padding: 8px 0px;
  z-index: 99;
  text-align: center;
  background-color: #503291;
  align-self: center;
  border-radius: 4px 0px 0px 4px;
  color: white;
`;
export { StyledDropdown, StyledDropdownWrapper, StyledDropdownButton };
